<template>
    <div class="header">
        <router-link to="/">
            <img src="./../assets/img/logo.png" alt="logo" class="logo">

        </router-link>
        <div class="menu-box">

            <img src="./../assets/img/menu.png" alt="" class="menu-btn"  @click="isnanshow=!isnanshow">

            <ul class="menu-nav" v-show="isnanshow" >
                <li v-for="(item,index) in navarr" :key="index">
                    <router-link :to="item.link" @click.native="isnanshow=!isnanshow">{{item.text}}</router-link>
                </li>
             
            </ul>

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            isnanshow:false,
            navarr:[
                {
                    text:'首页',
                    link:'/'
                },
                {
                    text:'公司介绍',
                    link:'/about'
                },
                {
                    text:'新闻中心',
                    link:'/news'
                },
                {
                    text:'解决方案',
                    link:'/social'
                },
                {
                    text:'成功案例',
                    link:'/cases'
                },
                {
                    text:'招商加盟',
                    link:'/investment'
                },
            ]
        }
    }
};
</script>
<style lang="scss" >
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.77rem;
  padding: 0 0.33rem;
  position: relative;
  z-index:2;
  .logo {
    width: 1.5rem;
  }
  >a{
      @extend .flex-cont;
  }
  
  .menu-box{
      position: relative;
      @extend .flex-cont;
      height:100%;
      .menu-btn{
          width:.33rem;
      }
      .menu-nav{
          position: absolute;
          right:-.33rem;
          top:.77rem;
          width:2.5rem;
        @extend .bg;
        
       
        a{
            font-size: .3rem;
            color:#fff;
            display: block;
            
            @include lineheight(.8rem);
            text-align: center;
        }
      }
  }
}
</style>

